
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetogoacabs() {



    const cardData =
    {
        keyword: 'Pune to Goa Cabs',
        heading: 'Meghana Cab : Pune to Goa Cabs',
        headingDescription: 'Meghana Cab offers Pune to Goa Cab services, delivering a comfortable and stress-free travel experience for beach lovers, families, and corporate travelers alike. Covering the scenic Pune–Goa route of approximately 450 kilometers, our professional drivers ensure a smooth, safe, and timely journey through lush Western Ghats. Choose from a wide range of clean and well-maintained cabs, including sedans, SUVs, and tempo travellers, tailored to your group size and budget. Whether you’re heading to Baga Beach, Calangute, or South Goa resorts, enjoy the flexibility of one-way or round-trip bookings with transparent fares and 24/7 customer assistance. Book your Pune to Goa Cab with Meghana Cab for a reliable, affordable, and memorable interstate travel experience.',


        top: 'Top Places to Visit in Goa with Meghana Cab',

"topPlaces": [
  {
    "title": "Calangute and Baga Beaches",
    "description": "Calangute and Baga Beaches are among the most famous shorelines of North Goa, drawing visitors with their golden sands, energetic beach shacks, and exciting water sports. Calangute, known as the ‘Queen of Beaches,’ is ideal for sunbathing, shopping, and family picnics, while Baga thrives at night with its lively clubs and music bars. Visitors can indulge in parasailing, banana rides, or enjoy Goan seafood delicacies by the sea. Both beaches offer a perfect mix of adventure and relaxation, making them essential stops on any Goa itinerary."
  },
  {
    "title": "Old Goa Churches",
    "description": "Old Goa stands as a living museum of Portuguese heritage, adorned with magnificent churches and cathedrals dating back to the 16th and 17th centuries. The UNESCO-listed Basilica of Bom Jesus enshrines the relics of St. Francis Xavier and features intricate Baroque architecture. The Sé Cathedral, one of Asia’s largest churches, impresses with its grand golden altars and serene courtyards. St. Cajetan and St. Augustine ruins nearby offer glimpses into Goa’s colonial past. The area radiates peace, spirituality, and architectural brilliance that narrate Goa’s centuries-old cultural fusion."
  },
  {
    "title": "Dudhsagar Falls and Mollem National Park",
    "description": "One of India’s tallest waterfalls, Dudhsagar cascades from a height of over 300 meters through the lush forests of Mollem National Park. Its name means ‘Sea of Milk,’ inspired by the white mist created as it gushes down in four tiers. The journey to the falls—by jeep or train through dense jungle—adds thrill to the experience. Mollem National Park is also home to exotic flora, fauna, and the ancient Tambdi Surla Temple. Together, they offer an incredible combination of adventure, nature, and spiritual tranquility deep in the Western Ghats."
  },
  {
    "title": "Chapora and Fort Aguada",
    "description": "Chapora Fort, perched dramatically above the Chapora River, is famous for its panoramic sunsets and the iconic Bollywood scene from 'Dil Chahta Hai'. The crumbling laterite walls whisper tales of Goa’s turbulent history. On the other hand, Fort Aguada, near SinQ and Candolim Beach, stands as a well-preserved 17th-century Portuguese fort with a majestic lighthouse overlooking the Arabian Sea. Visitors can stroll around its ancient ramparts, take in coastal views, and explore the nearby Aguada Jail. These forts beautifully capture Goa’s historic defense legacy and scenic allure."
  },
  {
    "title": "Anjuna Beach and Flea Market",
    "description": "Anjuna Beach is the heartbeat of Goa’s hippie culture, offering a perfect blend of laid-back charm and vibrant energy. Its rocky shorelines, yoga retreats, and trance parties attract free-spirited travelers from across the globe. The famous Wednesday Flea Market transforms the beach into a colorful carnival of handicrafts, boho clothing, silver jewelry, and street performances. Whether you’re shopping, sunbathing, or sipping coconut water under palm trees, Anjuna delivers the quintessential bohemian Goan vibe that continues to inspire artists and wanderers alike."
  },
  {
    "title": "Panaji and Fontainhas Latin Quarter",
    "description": "Goa’s capital city, Panaji, sits gracefully along the Mandovi River, blending old-world charm with modern flair. Its Latin Quarter, Fontainhas, is a UNESCO heritage area filled with narrow lanes, tiled houses, and pastel-painted Portuguese villas. Art galleries, bakeries, and boutique cafés line the streets, making it ideal for evening walks. Don’t miss the Church of Our Lady of the Immaculate Conception or the Mandovi sunset cruise. This district reflects Goa’s multicultural soul—where Portuguese nostalgia meets Indian warmth in every corner."
  },
  {
    "title": "Bondla Wildlife Sanctuary",
    "description": "Bondla Wildlife Sanctuary, located about 50 km from Panaji, is a compact yet beautiful reserve spread over 8 km². It’s home to a small zoo, deer park, botanical gardens, and an eco-resort, making it perfect for family excursions. The sanctuary shelters leopards, sambar deer, Indian bison, and several endemic birds like the Malabar pied hornbill. Educational tours and guided treks offer insight into Goa’s natural biodiversity. Away from the beaches, Bondla provides a refreshing glimpse of the state’s lush hinterlands and eco-conservation efforts."
  },
  {
    "title": "Spice Plantations and Tambdi Surla Temple",
    "description": "Located around Ponda, Goa’s spice plantations offer a sensory escape into aromatic estates growing pepper, cardamom, nutmeg, and cashews. Visitors are guided through tropical gardens, shown traditional distilling of cashew feni, and served local meals on banana leaves. Nearby lies the 12th-century Tambdi Surla Temple, dedicated to Lord Shiva, carved entirely out of basalt in the Kadamba style. Surrounded by dense forest and flowing streams, it stands as Goa’s oldest active temple, combining history, spirituality, and the fragrance of nature in one visit."
  },
  {
    "title": "Dona Paula Viewpoint",
    "description": "Dona Paula, a picturesque cape near Panaji, offers mesmerizing views where the Mandovi and Zuari rivers merge into the Arabian Sea. Its romantic legend—of a Portuguese noblewoman’s love and sacrifice—adds emotional depth to the site. The whitewashed statue called the ‘Image of India’ and the nearby jetty attract tourists for sunset photos and water-sport activities. With luxury hotels, street vendors, and breezy promenades, Dona Paula embodies Goa’s timeless blend of beauty, romance, and coastal tranquility."
  },
  {
    "title": "Goa Carnival and Cultural Festivals",
    "description": "The Goa Carnival, celebrated every February, is one of India’s most colorful and spirited events. Streets burst into life with samba dancers, music floats, masquerade parades, and food stalls serving Goan delicacies. The festival dates back to Portuguese times and marks the beginning of Lent. Beyond the Carnival, Goa hosts numerous cultural events—like the Shigmo Festival, Sunburn Music Festival, and Feast of St. Francis Xavier—that showcase its unique Indo-Latin essence. Each celebration reflects Goa’s joyous rhythm of life and welcoming spirit."
  }
],

"services": [
    {
      "name": "Pune to Goa Cab Service",
      "description": "Book reliable and affordable Pune to Goa cab service with Meghana Cab. Enjoy comfortable travel, timely pickups, and professional drivers for a seamless intercity journey to Goa."
    },
    {
      "name": "Pune to Goa Cab",
      "description": "Travel conveniently from Pune to Goa with Meghana Cab’s trusted taxi service. Choose from sedans, SUVs, and luxury cars suited for all travel needs."
    },
    {
      "name": "Pune to Goa Car Rental",
      "description": "Rent a car from Pune to Goa with Meghana Cab for complete flexibility. Our well-maintained vehicles ensure a safe and enjoyable drive along scenic routes."
    },
    {
      "name": "Pune to Goa Taxi",
      "description": "Hire a taxi from Pune to Goa for a comfortable and timely ride. Meghana Cab offers professional drivers and clean vehicles for a stress-free journey."
    },
    {
      "name": "Pune to Goa Taxi Fare",
      "description": "Check affordable Pune to Goa taxi fares with Meghana Cab. Transparent pricing with no hidden charges ensures great value for your intercity travel."
    },
    {
      "name": "Pune to Goa Cab Package",
      "description": "Choose from customized Pune to Goa cab packages with Meghana Cab. Perfect for family trips, weekend getaways, or business travel."
    },
    {
      "name": "Pune to Goa Cab Fare",
      "description": "Get competitive Pune to Goa cab fares with Meghana Cab. Affordable rates and comfortable rides make long-distance travel convenient."
    },
    {
      "name": "Best Cab Service from Pune to Goa",
      "description": "Experience the best cab service from Pune to Goa with Meghana Cab. We provide top-rated cars, punctual service, and courteous drivers for a pleasant journey."
    },
    {
      "name": "Cab Service from Pune to Goa",
      "description": "Meghana Cab offers dependable cab service from Pune to Goa with various vehicle options, ensuring comfort, safety, and timely drop-offs."
    },
    {
      "name": "Car Hire Pune to Goa",
      "description": "Hire a car from Pune to Goa with Meghana Cab for a smooth and flexible trip. Ideal for travelers seeking personalized travel solutions."
    },
    {
      "name": "Car Rental Pune to Goa",
      "description": "Enjoy easy car rental from Pune to Goa through Meghana Cab. Choose from a range of vehicles maintained for safety, comfort, and performance."
    },
    {
      "name": "Goa Pune Cab Service",
      "description": "Book Goa to Pune cab service with Meghana Cab for your return journey. Experience comfort and reliability with our professional drivers and clean vehicles."
    },
    {
      "name": "Goa to Pune Car Rental",
      "description": "Rent a car from Goa to Pune with Meghana Cab. Perfect for return trips, offering flexibility and comfort at competitive prices."
    },
    {
      "name": "One Way Cab from Pune to Goa",
      "description": "Travel affordably with Meghana Cab’s one-way cab service from Pune to Goa. Ideal for travelers who need a single trip without return charges."
    },
    {
      "name": "Pune to Goa Cab Rental",
      "description": "Rent a cab from Pune to Goa for stress-free travel with Meghana Cab. Choose from AC sedans, SUVs, and premium cars for every budget."
    },
    {
      "name": "Pune to Goa Cab Cost",
      "description": "Find out the Pune to Goa cab cost with Meghana Cab’s transparent pricing. Get competitive rates and no hidden fees for your intercity trip."
    },
    {
      "name": "Pune to Goa Cab Service Fare",
      "description": "Compare Pune to Goa cab service fares easily with Meghana Cab. We offer flexible packages and affordable pricing for all travelers."
    },
    {
      "name": "Pune to Goa Cab Service Rates",
      "description": "Check Pune to Goa cab service rates online with Meghana Cab. Transparent pricing and comfortable rides for your long-distance journey."
    },
    {
      "name": "Pune to Goa Car Booking",
      "description": "Book your car from Pune to Goa effortlessly with Meghana Cab. Our user-friendly booking and reliable service make travel easy and comfortable."
    },
    {
      "name": "Pune to Goa Car Hire",
      "description": "Hire a private car from Pune to Goa with Meghana Cab for a relaxed and enjoyable trip. Perfect for individuals, families, or corporate travel."
    },
    {
      "name": "Pune to Goa Car Rental Price",
      "description": "Get the best Pune to Goa car rental price with Meghana Cab. Affordable rates and clean cars ensure great value for your travel."
    },
    {
      "name": "Pune to Goa Innova Rental",
      "description": "Book an Innova for your Pune to Goa trip with Meghana Cab. Spacious and comfortable, perfect for family or group travel."
    },
    {
      "name": "Pune to Goa One Way Cab",
      "description": "Enjoy convenient one-way cab rides from Pune to Goa with Meghana Cab. Perfect for travelers needing flexible, single-direction trips."
    },
    {
      "name": "Pune to Goa One Way Taxi",
      "description": "Book a one-way taxi from Pune to Goa with Meghana Cab. Comfortable, safe, and affordable intercity travel made easy."
    },
    {
      "name": "Pune to Goa Private Cab",
      "description": "Travel privately from Pune to Goa with Meghana Cab. Enjoy a personal, secure, and comfortable journey at your own schedule."
    },
    {
      "name": "Pune to Goa Taxi Fare One Way",
      "description": "Check Pune to Goa one-way taxi fare with Meghana Cab. Affordable pricing for solo or group travelers needing a single journey."
    },
    {
      "name": "Pune to Goa Taxi Packages",
      "description": "Explore Pune to Goa taxi packages from Meghana Cab. Tailored for leisure trips, group travel, or weekend getaways with fixed pricing."
    },
    {
      "name": "Pune to Goa Taxi Service",
      "description": "Meghana Cab provides reliable Pune to Goa taxi service. Our professional drivers and clean vehicles ensure a comfortable travel experience."
    },
    {
      "name": "Pune to Goa Innova Crysta Cab",
      "description": "Travel luxuriously with Pune to Goa Innova Crysta Cab by Meghana Cab. Spacious interiors, smooth rides, and perfect for family or corporate trips."
    }
  ],

  "tableData": [
    ["Pune to Goa Cab Service", "Pune to Goa Cab"],
    ["Pune to Goa Car Rental", "Pune to Goa Taxi"],
    ["Pune to Goa Taxi Fare", "Pune to Goa Cab Package"],
    ["Pune to Goa Cab Fare", "Best Cab Service from Pune to Goa"],
    ["Cab Service from Pune to Goa", "Car Hire Pune to Goa"],
    ["Car Rental Pune to Goa", "Goa Pune Cab Service"],
    ["Goa to Pune Car Rental", "One Way Cab from Pune to Goa"],
    ["Pune to Goa Cab Rental", "Pune to Goa Cab Cost"],
    ["Pune to Goa Cab Service Fare", "Pune to Goa Cab Service Rates"],
    ["Pune to Goa Car Booking", "Pune to Goa Car Hire"],
    ["Pune to Goa Car Rental Price", "Pune to Goa Innova Rental"],
    ["Pune to Goa One Way Cab", "Pune to Goa One Way Taxi"],
    ["Pune to Goa Private Cab", "Pune to Goa Taxi Fare One Way"],
    ["Pune to Goa Taxi Packages", "Pune to Goa Taxi Service"],
    ["Pune to Goa Innova Crysta Cab", ""],
    ["", ""]
  ],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Goa Cab Service",
        "WhyChoosedescription": "Meghana Cab provides trustworthy and comfortable cab services from Pune to Goa. Whether it's a beach vacation, business trip, or family getaway, enjoy a hassle-free ride in our well-maintained vehicles."
    },
    {
        "WhyChooseheading": "On-Time Pick-Up and Drop in Goa",
        "WhyChoosedescription": "Punctuality is our promise. We ensure timely pick-ups from Pune and smooth drop-offs at any location in Goa, including Panaji, Calangute, Baga, or South Goa destinations."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Pune-Goa Route",
        "WhyChoosedescription": "Our drivers are well-versed with the Pune to Goa route, ensuring a safe and efficient journey. They are trained in long-distance driving and prioritize your comfort throughout the trip."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Meghana Cab offers competitive fares for Pune to Goa travel with no hidden charges. Enjoy budget-friendly rates and full pricing transparency for peace of mind."
    },
    {
        "WhyChooseheading": "Clean and Safe Vehicles",
        "WhyChoosedescription": "All our cabs are sanitized before each trip and equipped with safety features such as GPS tracking, seat belts, and emergency assistance to ensure a secure journey."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability to Goa",
        "WhyChoosedescription": "Whether you need a late-night ride or an early morning start, Meghana Cab operates round the clock to meet your Pune to Goa travel needs at any hour."
    },
    {
        "WhyChooseheading": "Flexible Trip Options",
        "WhyChoosedescription": "Choose from one-way, round trip, or multi-stop journeys between Pune and Goa. Our customizable packages allow you to travel as per your schedule and convenience."
    },
    {
        "WhyChooseheading": "Quick Online Booking and Support",
        "WhyChoosedescription": "Book your Pune to Goa cab easily via our website or app. Need help? Our dedicated support team is always available to assist you with your bookings and queries."
    }
]



















    }

const faqData = [
    {
        question: "How can I book a Pune to Goa cab with Meghana Cab?",
        answer: "You can book a Pune to Goa cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What cab options are available for travel from Pune to Goa?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers for Pune to Goa trips, depending on your group size and comfort preference."
    },
    {
        question: "Is one-way cab service available from Pune to Goa?",
        answer: "Yes, we offer both one-way and round-trip cab services from Pune to various destinations in Goa."
    },
    {
        question: "How long does it take to travel from Pune to Goa by cab?",
        answer: "The journey from Pune to Goa typically takes around 9 to 12 hours, depending on traffic and the route chosen."
    },
    {
        question: "Are tolls and taxes included in the cab fare for Pune to Goa?",
        answer: "Tolls, state taxes, and parking charges are additional and are clearly communicated during the booking process."
    },
    {
        question: "Are Meghana Cab drivers experienced for long-distance travel like Pune to Goa?",
        answer: "Yes, our drivers are experienced, professional, and well-acquainted with long-distance routes including Pune to Goa."
    },
    {
        question: "Can I request breaks or custom stops during the Pune to Goa journey?",
        answer: "Yes, you can request halts or breaks during the trip. Just let us know your requirements while booking."
    },
    {
        question: "Is the cab service from Pune to Goa available at night?",
        answer: "Yes, Meghana Cab provides 24/7 service, so you can book a cab for day or night travel as per your convenience."
    },
    {
        question: "What payment options are accepted for Pune to Goa cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for all bookings."
    },
    {
        question: "How do I contact Meghana Cab to book a Pune to Goa cab?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Nilesh Naik',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab made our Pune to Goa trip extremely comfortable. The car was clean, and the driver knew the route well. A hassle-free experience!”',
    },
    {
        name: 'Ms. Riya Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I highly recommend Meghana Cab for Pune to Goa travel. On-time pickup, smooth ride, and the support team was very responsive.”',
    },
];













































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Cabs",
  "description": "Reliable and comfortable Pune to Goa cab service by Meghana Cabs. Affordable fares with flexible packages for one-way and round trips. Book your Pune to Goa taxi today for a hassle-free journey!",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5283"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Goa Cabs | Best Cab Service from Pune to Goa </title>
  <meta
    name="description"
    content="Book Pune to Goa cab service with Meghana Cabs. Affordable Pune to Goa taxi, car rental, and cab packages. Comfortable one-way and round trip car hire with reliable service."
  />
  <meta
    name="keywords"
    content="Pune to goa cab service, Pune to goa cab, Pune to goa car rental, Pune to goa taxi, Pune to goa taxi fare, Pune to goa cab package, Pune to goa cab fare, Best cab service from pune to goa, Cab service from pune to goa, Car hire pune to goa, car rental pune to goa, goa pune cab service, goa to pune car rental, One way cab from pune to goa, Pune to goa cab rental, Pune to goa cab cost, Pune to goa cab service fare, pune to goa cab service rates, Pune to goa car booking, Pune to goa car hire, pune to goa car rental price, Pune to goa innova rental, Pune to goa one way cab, Pune to goa one way taxi, Pune to goa private cab, Pune to goa taxi fare one way, pune to goa taxi packages, pune to goa taxi service, pune to goa innova crysta Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/55.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogoacabs;